import React, { useState, useRef } from 'react';

function TooltipButton({ Content, ContentText, MaxWidth = '100px', Position = 'top' }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const buttonRef = useRef(null);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  // Dynamic styles for the tooltip based on Position
  const tooltipStyle = {
    position: 'absolute',
    backgroundColor: '#3C3C3C',
    color: '#FFFFFF',
    padding: '5px 10px',
    borderRadius: '5px',
    whiteSpace: 'normal',
    // lineHeight: '16.94px',
    maxWidth: MaxWidth,
    minWidth: MaxWidth,
    fontSize: '14px',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    zIndex: 111,
    transform: 'translateY(-50%)',
    ...(Position === 'top' && {
      top: buttonRef.current ? buttonRef.current.offsetTop - 10 : 0,
      left: buttonRef.current
        ? buttonRef.current.offsetLeft + buttonRef.current.offsetWidth / 2
        : 0,
      transform: 'translate(-50%, -100%)',
    }),
    ...(Position === 'bottom' && {
      top: buttonRef.current
        ? buttonRef.current.offsetTop + buttonRef.current.offsetHeight + 10
        : 0,
      left: buttonRef.current
        ? buttonRef.current.offsetLeft + buttonRef.current.offsetWidth / 2
        : 0,
      transform: 'translate(-50%, 0)',
    }),
    ...(Position === 'right' && {
      top: buttonRef.current ? buttonRef.current.offsetTop + buttonRef.current.offsetHeight / 2 : 0,
      left: buttonRef.current
        ? buttonRef.current.offsetLeft + buttonRef.current.offsetWidth + 10
        : 0,
      transform: 'translateY(-50%)',
    }),
    ...(Position === 'left' && {
      top: buttonRef.current ? buttonRef.current.offsetTop + buttonRef.current.offsetHeight / 2 : 0,
      left: buttonRef.current ? buttonRef.current.offsetLeft - MaxWidth.replace('px', '') - 10 : 0,
      transform: 'translate(-100%, -50%)',
    }),
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div ref={buttonRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {Content}
      </div>
      {showTooltip && <div style={tooltipStyle}>{ContentText}</div>}
    </div>
  );
}

export default TooltipButton;
